import { Card, Column, Modal, Row, Spacer, } from '@components/1-atoms';
import React, { FC } from 'react';

import Text from '@components/1-atoms/Text';
import ListItem from '@components/2-molecules/ListItem';
import { View } from 'react-native';

import useTheme from '@lib/theme';

import MenuIcon from '@assets/icons/plus';
import { PageProps } from '@lib/constants';

import ProductsServicesMenu from '@components/3-organisms/Menus/MenuProductsServices';

import Illustration from "@assets/inventory-illustration";

const theme = useTheme();
const icon = /* null; // */ <MenuIcon />;


type Props = Omit<PageProps, 'data'> & {};

const WidgetCreateInventory: FC<Props> = ({ navigation, ...props }) => {

    const [isModalVisible, setModalVisiblility] = React.useState(false);
    const openModal = () => setModalVisiblility(true);
    const closeModal = () => setModalVisiblility(false);

    return (
        <>
            <Modal visible={isModalVisible} title={"Create an inventory"} onClose={closeModal}>
                <ProductsServicesMenu navigation={navigation} />
            </Modal>

            <Card
                themed={false}
                // icon={icon}
                // onAction={ openModal}
                title='Create an inventory'
            >

                <View>
                    <Spacer h={3} />

                    {/* Illustration */}
                    <Row style={{ justifyContent: 'flex-start' }}>
                        <Illustration />
                    </Row>
                    <Spacer h={.9} />

                    {/* Description */}
                    <Row>
                        <Column>
                            <Text>Add the products and services you sell to your customers, and get an overview of your inventory.</Text>
                        </Column>
                    </Row>
                    <Spacer h={3} />

                </View>

                {/* Create inventory */}
                <View>
                    <ListItem inset onPress={openModal}>
                        <Text color={theme.pallete.accentColor}>Create an inventory</Text>
                    </ListItem>
                </View>

            </Card>
        </>
    );
};

export default WidgetCreateInventory;